exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3eZx2eKC36FVmXMNKZX52H{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;height:auto;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._1iRb-GTx0stc2jGovVRbbK{position:relative;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}", ""]);
// Exports
exports.locals = {
	"mainContent": "_3eZx2eKC36FVmXMNKZX52H",
	"surfaceContainer": "_1iRb-GTx0stc2jGovVRbbK"
};